import { Component, OnChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';

@Component({
  selector: 'app-doctors-next-reset-password',
  templateUrl: './doctors-next-reset-password.component.html',
  styleUrls: [
    './doctors-next-reset-password.component.css',
    '../style/index.css',
  ],
})
export class DoctorsNextResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnChanges
{
  errorMessageDict: {
    passwordNotInput: string;
    confirmPasswordNotInput: string;
    passwordNotMatch: string;
  } = {
    passwordNotInput: 'パスワードを入力してください。',
    confirmPasswordNotInput: 'パスワードを入力してください。',
    passwordNotMatch: 'パスワードが一致しませんでした。',
  };
  constructor(title: Title) {
    super();
    title.setTitle('New Password');
    this.errorMessages.confirmPassword;
  }

  get errors() {
    return [
      this.errorMessages.password,
      this.errorMessages.confirmPassword,
    ].filter((msg) => msg);
  }
}
